var module;
// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, node:true*/
(function () {
  var is_node = typeof module == 'object' && module.exports;
  if (!is_node) ;else ;
  define(['/util/country.js', 'jquery', '/util/etask.js'], function (country, $, etask) {
    var E = {
      psk: '12345678'
    };
    var top_countries = ['us', 'uk', 'ca'];
    E.ensure_vpn_info = function (force_new_password) {
      var backend_url = '/users/ensure_vpn_info';
      return force_new_password ? $.post(backend_url, {
        force_new_password: true
      }) : $.get(backend_url);
    };
    E.get_countries_options = etask.fn([function () {
      return $.get('/users/get_vpn_countries');
    }, function (countries) {
      var reverse = {},
        labels = [],
        options = [],
        i;
      for (i = 0; i < countries.length; i++) {
        var label = country.list[countries[i].toUpperCase()];
        reverse[label] = countries[i];
        labels.push(label);
      }
      labels.sort();
      for (i = 0; i < top_countries.length; i++) {
        if (countries.indexOf(top_countries[i]) != -1) {
          options.push({
            val: top_countries[i],
            top: true,
            text: country.list[top_countries[i].toUpperCase()]
          });
        }
      }
      options.push({
        disabled: true,
        role: 'separator',
        text: '\u2014\u2014\u2014\u2014\u2014\u2014\u2014\u2014'
      });
      for (i = 0; i < labels.length; i++) options.push({
        val: reverse[labels[i]],
        text: labels[i]
      });
      return options;
    }]);
    E.is_premium_dns_used = etask.fn([function () {
      return $.get('//dnscheck.hola.org/check.txt');
    }, function catch$(e) {}]);
    E.get_mac_profile_url = function (p) {
      var proto = {
        l2tp: 'L2TP',
        pptp: 'PPTP',
        ikev2: 'IKEv2'
      }[p] || 'IKEv2';
      return '/users/download_apple_profile?protocol=' + proto;
    };
    return E;
  });
})();